var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BE3E76ED-37E8-439C-9728-B4E296175F13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Menu",
    transform: "translate(-32.000000, -223.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(32.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-icon",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64966239,0.168980915 L15.3163291,3.88871607 C15.7384184,4.12422513 16,4.56972193 16,5.05306849 L16,14.4731618 C16,15.2095414 15.4030463,15.8064951 14.6666667,15.8064951 L11.348348,15.8064951 C10.6119683,15.8064951 10.0150146,15.2095414 10.0150146,14.4731618 L10.0150146,12.1398284 C10.0150146,11.4034488 9.41806098,10.8064951 8.68168132,10.8064951 L7.33342489,10.8064951 C6.59704522,10.8064951 6.00009155,11.4034488 6.00009155,12.1398284 L6.00009155,14.4731618 C6.00009155,15.2095414 5.40313789,15.8064951 4.66675822,15.8064951 L1.33333333,15.8064951 C0.596953667,15.8064951 0,15.2095414 0,14.4731618 L0,5.05306849 C0,4.56972193 0.261581644,4.12422513 0.683670941,3.88871607 L7.35033761,0.168980915 C7.75414393,-0.0563269718 8.24585607,-0.0563269718 8.64966239,0.168980915 Z M8.12993248,1.10046285 C8.06532347,1.06441359 7.98946251,1.05720374 7.92035272,1.07883329 L7.87006752,1.10046285 L1.20340085,4.820198 C1.13586657,4.85787945 1.08887726,4.92243933 1.07278291,4.99625071 L1.06666667,5.05306849 L1.06666667,14.4731618 C1.06666667,14.6020282 1.1580752,14.7095451 1.2795907,14.7344107 L1.33333333,14.7398284 L4.66675822,14.7398284 C4.79562466,14.7398284 4.9031415,14.6484199 4.92800717,14.5269044 L4.93342489,14.4731618 L4.93342489,12.1398284 C4.93342489,10.8571026 5.93973596,9.80941325 7.2059634,9.74315517 L7.33342489,9.73982844 L8.68168132,9.73982844 C9.96440719,9.73982844 11.0120965,10.7461395 11.0783546,12.012367 L11.0816813,12.1398284 L11.0816813,14.4731618 C11.0816813,14.6020282 11.1730898,14.7095451 11.2946053,14.7344107 L11.348348,14.7398284 L14.6666667,14.7398284 C14.7955331,14.7398284 14.9030499,14.6484199 14.9279156,14.5269044 L14.9333333,14.4731618 L14.9333333,5.05306849 C14.9333333,4.97573304 14.8998509,4.90324236 14.843236,4.85322337 L14.7965991,4.820198 L8.12993248,1.10046285 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2dda159d9234a8b99900ca5567878dcf.svg";
export { ForwardRef as ReactComponent };